.avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  overflow: hidden;
  user-select: none;
  font-weight: 600;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  flex-shrink: 0;
}

.image {
  object-fit: cover;
}

.initials {
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
  background-color: #4f46e5;
  color: #ffffff;
}

.sm {
  width: 32px;
  height: 32px;
  font-size: 14px;
}

.md {
  width: 44px;
  height: 44px;
  font-size: 18px;
}

.lg {
  width: 96px;
  height: 96px;
  font-size: 36px;
}